import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  chemAdjustmentConfigByNodeId: {},
  // Stores full API response per nodeId for cache-hit checks
  chemicalAdjustmentByNodeId: {},
  // Raw save payload per nodeId awaiting persistence when Auto Save is off (flushed on project Save)
  pendingChemAdjustmentByNodeId: {},
};

export const ChemicalAdjustmentSlice = createSlice({
  name: "chemicalAdjustment",
  initialState,
  reducers: {
    setCaseChemicalAdjustmentList: (state, action) => {
      state.chemAdjustmentConfigByNodeId = {
        ...state.chemAdjustmentConfigByNodeId,
        ...(action.payload || {}),
      };
    },
    setAdjustmentResponseForNode: (state, action) => {
      const { nodeId, response } = action.payload;
      state.chemicalAdjustmentByNodeId[nodeId] = response;
    },
    setPendingChemAdjustment: (state, action) => {
      const { nodeId, data } = action.payload;
      state.pendingChemAdjustmentByNodeId[nodeId] = data;
    },
    clearPendingChemAdjustment: (state, action) => {
      delete state.pendingChemAdjustmentByNodeId[action.payload];
    },
    resetChemicalAdjustmentData: state => {
      state.chemAdjustmentConfigByNodeId = {};
      state.chemicalAdjustmentByNodeId = {};
      state.pendingChemAdjustmentByNodeId = {};
    },
  },
});

export const {
  setCaseChemicalAdjustmentList,
  setAdjustmentResponseForNode,
  setPendingChemAdjustment,
  clearPendingChemAdjustment,
  resetChemicalAdjustmentData,
} = ChemicalAdjustmentSlice.actions;

export default ChemicalAdjustmentSlice.reducer;
